import script from "./GameRematchOverlay.vue?vue&type=script&setup=true&lang=js"
export * from "./GameRematchOverlay.vue?vue&type=script&setup=true&lang=js"

import "./GameRematchOverlay.vue?vue&type=style&index=0&id=f74f496c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f74f496c"]])

export default __exports__